import React, { useState } from "react"
import UserEditForm from "../components/UserEditForm"
import Header from "../components/Header"
import { Paper } from "@mui/material"
import { spacing } from "./services/styleServices"

const styles = {
    pageContent: {
        margin: spacing(1),
        padding: spacing(1),
    },
}

function UserEdit(props) {
    const [title, setTitle] = useState("Edit User")

    return (
        <Header title={title}>
            <Paper sx={styles.pageContent}>
                <UserEditForm {...props} setTitle={setTitle} />
            </Paper>
        </Header>
    )
}

export default UserEdit
